import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private injector: Injector) { 

  }


  handleError(error: any) {
    
    const modalService = this.injector.get(NgbModal);
    modalService.dismissAll();

    // Ignorar errores de permisos de Firestore para usuarios que aún no tienen kyc.result = 1
    // Estos errores se manejan localmente en los componentes
    if (error?.code === 'permission-denied' || 
        (error?.message && error.message.includes('Missing or insufficient permissions'))) {
      // No loguear estos errores ya que se manejan localmente
      return;
    }

    console.error(error);
  }

}
